import isBrowser from './is-browser';

const isApplePaySupported = Boolean(isBrowser && window.ApplePaySession);

export default isApplePaySupported;
